import type { ReactNode } from 'react';

export type CommunicationDetailsHeaderProps = {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
};

export function CommunicationDetailsHeader({
  title,
  subtitle,
  actions,
}: CommunicationDetailsHeaderProps) {
  return (
    <div className="flex items-center justify-between rounded-lg p-4">
      <div>
        <h1 className="font-condensed text-2xl font-bold text-gray-800">
          {title}
        </h1>
        <div className="mt-2 text-sm text-gray-600">{subtitle}</div>
      </div>
      <div>{actions}</div>
    </div>
  );
}
